import { Moment } from 'moment';

export const DEFAULT_COACHING_SESSION_DURATION = 30 * 60; // 30min
export const DEFAULT_THERAPY_SESSION_DURATION = 60 * 60; // 60min

export const DEFAULT_LATE_CANCELLATION_THRESHOLD = 24 * 60 * 60;

export interface SessionUtilizationInfo {
    coachingVisitsRemaining: number;
    therapyVisitsRemaining: number;
    resetDate: Moment;
    coveredTherapyVisits: number;
    coveredCoachingVisits: number;
}

export interface StringifiedSessionSlot {
    start: string;
    end: string;
}

export interface SessionSlot {
    start: Moment;
    end: Moment;
}

export interface DateWithSessionSlots {
    date: Moment;
    slots: SessionSlot[];
}

export enum PositiveFeedback {
    ListenedToMe = 'LISTENED_TO_ME',
    AskedGoodQuestions = 'ASKED_GOOD_QUESTIONS',
    ChallengedMe = 'CHALLENGED_ME',
    SupportedMe = 'SUPPORTED_ME',
    DevelopedAPlan = 'DEVELOPED_A_PLAN',
    UnderstoodMe = 'UNDERSTOOD_ME',
}

export enum ConstructiveFeedback {
    ListenedMore = 'LISTENED_MORE',
    AskedBetterQuestions = 'ASKED_BETTER_QUESTIONS',
    MoreEngaging = 'MORE_ENGAGING',
    MoreSupportive = 'MORE_SUPPORTIVE',
    LessDirective = 'LESS_DIRECTIVE',
    MoreEmpathetic = 'MORE_EMPATHETIC',
}

export const positiveAnswersOptions = [
    { text: 'positive_feedback.listened_to_me', value: PositiveFeedback.ListenedToMe },
    { text: 'positive_feedback.asked_good_questions', value: PositiveFeedback.AskedGoodQuestions },
    { text: 'positive_feedback.challenged_me', value: PositiveFeedback.ChallengedMe },
    { text: 'positive_feedback.supported_me', value: PositiveFeedback.SupportedMe },
    { text: 'positive_feedback.developed_a_plan', value: PositiveFeedback.DevelopedAPlan },
    { text: 'positive_feedback.understood_me', value: PositiveFeedback.UnderstoodMe },
];

export enum FeedbackPamm {
    EaseOfAccess = 'EASE_OF_ACCESS',
    QualityOfCare = 'QUALITY_OF_CARE',
    Privacy = 'PRIVACY',
    Communication = 'COMMUNICATION',
    RemoteVisit = 'REMOTE_VISIT',
    Treatment = 'TREATMENT',
}

export const answersOptionsPamm = [
    { text: 'feedback.psychiatry.ease_of_access', value: FeedbackPamm.EaseOfAccess },
    { text: 'feedback.psychiatry.quality_of_care', value: FeedbackPamm.QualityOfCare },
    { text: 'feedback.psychiatry.privacy', value: FeedbackPamm.Privacy },
    { text: 'feedback.psychiatry.communication', value: FeedbackPamm.Communication },
    { text: 'feedback.psychiatry.remote_visit', value: FeedbackPamm.RemoteVisit },
    { text: 'feedback.psychiatry.treatment', value: FeedbackPamm.Treatment },
];

export const answersOptionsPammContinueWorking = [
    { text: 'providers:demographic_feedback_modal.answer.yes', value: 'Yes' },
    { text: 'providers:demographic_feedback_modal.answer.no', value: 'No' },
];
export const constructiveAnswersOptions = [
    { text: 'constructive_feedback.listened_more', value: ConstructiveFeedback.ListenedMore },
    {
        text: 'constructive_feedback.asked_better_questions',
        value: ConstructiveFeedback.AskedBetterQuestions,
    },
    { text: 'constructive_feedback.more_engaging', value: ConstructiveFeedback.MoreEngaging },
    { text: 'constructive_feedback.more_supportive', value: ConstructiveFeedback.MoreSupportive },
    { text: 'constructive_feedback.less_directive', value: ConstructiveFeedback.LessDirective },
    { text: 'constructive_feedback.more_empathetic', value: ConstructiveFeedback.MoreEmpathetic },
];

export enum VisitState {
    Scheduled = 'SCHEDULED',
    PendingPayment = 'PENDING_PAYMENT',
    PendingConfirmation = 'PENDING_CONFIRMATION',
}
